<script setup lang="ts">
definePageMeta({
  title: 'Request a Quote',
  label: 'Submit RFQ',
  description: 'Request a quote for a discrete assembly or wire harness from ICS.',
  order: 0,
})
</script>

<template>
  <BlockContent
    element="section"
    class="space-y-4"
  >
    <div class="flex flex-col gap-y-4 f-gap-x-32-64 sm:flex-row">
      <AButton
        label="Send Us an Email"
        size="xlarge"
        color="blue"
        material="empty"
        icon="i-carbon-arrow-right"
        icon-side="right"
        to="/contact"
      />
      <h1 class="subpage-title sm:order-first">
        Request a Quote
      </h1>
    </div>
    <p>Get a quote for a discrete assembly or wire harness from ICS.</p>
    <HubspotForm form-id="8263ce73-0da4-48e8-aae2-c29a0f118cb8" />
  </BlockContent>
</template>
